import styled from "styled-components"

import ModalBase from "@irati/ui/src/Modal"
import {minWidthMedia} from "@irati/ui/src/global/media"
import padding from "@irati/ui/src/global/padding"

const StyledModal = styled(ModalBase)`
  ${minWidthMedia.phone`
    .modal-dialog {
      width: 400px;
      margin: ${padding.base} auto;
    }
  `}
  ${minWidthMedia.tablet`
    .modal-dialog {
      width: 400px;
      margin: ${padding.base} auto;
    }
  `}
  ${ModalBase.Inner} {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .onboarding-slider-list {
    .slick-list {
      transition: height .4s ease-in-out;
    }
    .slick-slide {
      visibility: hidden;
      opacity: 0;
      transition: opacity .4s ease-in-out;
    }
    .slick-current {
      visibility: visible;
      opacity: 1;
    }
  }
`
export default StyledModal
